import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

export type ConsentStateParams = {
    consent: number
};


export class ConsentStateCommand extends JsToClientCommand<ConsentStateParams> {
    constructor(params: ConsentStateParams) {
        super(ClientCommands.CONSENT_STATE, {
            // eslint-disable-next-line no-nested-ternary
            consent: params.consent
        });
    }
}
